"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const Flex_1 = tslib_1.__importStar(require("./Elements/Flex"));
const Texts_1 = require("./Texts");
const TooltipPanel = (0, styled_components_1.default)(Flex_1.default) `
  display: none;
  position: absolute;
  top: 110%;
  z-index: 10000000;
  color: black;

  box-shadow: 0 2px 8px 0 rgba(89, 99, 109, 0.1);
  border-radius: 5px;
  background-color: white;
  padding: 0.5em 1em;
`;
const CustomFlex = (0, styled_components_1.default)(Flex_1.default) `
  position: relative;
  :hover {
    ${TooltipPanel} {
      display: flex;
    }
    &.active {
      color: ${props => props.highlightedColor};
      cursor: pointer;
    }
  }
`;
const Tooltip = ({ content, disable, highlightedColor, children, ...restProps }) => {
    const [flexProps, notFlexProps] = (0, Flex_1.extractFlex)(restProps);
    const { paddings: paddingProps, margins: marginProps } = (0, StyledFunctions_1.extractMarginAndPadding)(notFlexProps);
    return (react_1.default.createElement(CustomFlex, { flexDirection: "column", flex: "1", ...flexProps, ...paddingProps, ...marginProps, className: disable ? undefined : 'active', highlightedColor: highlightedColor },
        children,
        !disable && (react_1.default.createElement(TooltipPanel, null,
            react_1.default.createElement(Texts_1.NormalText, null, content)))));
};
Tooltip.defaultProps = { disable: false };
exports.default = Tooltip;
